var _defs, _path, _path2, _path3, _path4, _path5, _polygon, _g, _path6, _path7, _path8, _path9, _polygon2, _g2, _g3, _rect, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _ellipse, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _path29, _polygon3, _rect9, _path30, _ellipse2, _path31, _path32, _path33, _circle, _path34, _path35, _path36, _path37, _path38, _path39, _rect10, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _g4, _path52, _path53, _path54, _path55, _path56, _polygon4, _polygon5, _polygon6, _path57, _ellipse3, _ellipse4, _path58, _path59, _path60, _path61, _ellipse5, _ellipse6, _path62, _path63, _path64, _circle2, _path65, _path66, _path67, _path68, _polygon7, _path69, _path70, _polygon8, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _ellipse7, _path79, _ellipse8, _path80, _path81, _path82, _ellipse9, _ellipse10, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _ellipse11, _ellipse12, _path91, _path92, _path93, _path94, _path95, _ellipse13, _ellipse14, _path96, _path97, _path98, _path99, _path100;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCandidateSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 865.76,
    height: 682.89,
    viewBox: "0 0 865.76 682.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "368.06 30.61 368.06 112.13 440.69 112.13 440.69 30.22 368.06 30.61",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "413.54 163.01 536.67 163.01 536.67 321.52 410.32 321.52 413.54 163.01",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M56.44,124.79S85.89,34.5,218.83,43.09c0,0,53.54-.78,112.65,20.3,0,0,100.49,36.66,161.39,39.41,0,0,162.39-7.4,170.2,106.59,0,0,30.44,143.65-140.54,206.11,0,0-149.9,58.55-317,11.71,0,0-127.26-28.11-160-135.07C45.51,292.14,15.84,211,56.44,124.79Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 182.82,
    y: 148.54,
    width: 148.66,
    height: 181.91,
    fill: "#fff"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.44,124.79S85.89,34.5,218.83,43.09c0,0,53.54-.78,112.65,20.3,0,0,100.49,36.66,161.39,39.41,0,0,162.39-7.4,170.2,106.59,0,0,30.44,143.65-140.54,206.11,0,0-149.9,58.55-317,11.71,0,0-127.26-28.11-160-135.07C45.51,292.14,15.84,211,56.44,124.79Z",
    fill: "#1A1A1A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.44,124.79S85.89,34.5,218.83,43.09c0,0,53.54-.78,112.65,20.3,0,0,100.49,36.66,161.39,39.41,0,0,162.39-7.4,170.2,106.59,0,0,30.44,143.65-140.54,206.11,0,0-149.9,58.55-317,11.71,0,0-127.26-28.11-160-135.07C45.51,292.14,15.84,211,56.44,124.79Z",
    fill: "#fff",
    opacity: 0.7
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M351.77,42.73c0-19.89,12.74-20.09,12.74-20.09l106.82.1c-15,1.51-15.29,20-15.29,20l2.27,85.08h2.82c-2.31,2.31-2.69,14.25-2.69,14.25H346.59a5.46,5.46,0,0,1-5.32-4.26c-1.07-4.58-1.69-11.72,3.21-15.58a1.25,1.25,0,0,1,2,.82,7.13,7.13,0,0,0,5.3,6.08Z",
    fill: "#fddfd2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M472.31,37.12c-5.56-.27-15.12.64-16.16,9.79,0,0-2.75-21.6,15.18-24.17,0,0,4.18,1.59,4.89,10.28A3.77,3.77,0,0,1,472.31,37.12Z",
    fill: "#fcd6ca"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M458,117.52s-56.1,18.56-106.26,5.81v5.79s74.7,7.43,106.54-1.31Z",
    fill: "#fcd6ca"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "368.06 30.61 368.06 112.13 440.69 112.13 440.69 30.22 368.06 30.61",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M397.21,245.26l-2.33,1.94a8,8,0,0,1-3.61,1.16H384.9c-1.31,0-.77-1.36-.77-1.36a.65.65,0,0,0,.62.44h5.67c2.64.32,5.94-2.62,6.73-3.37a1.07,1.07,0,0,0,.28-.42c0-.08.05-.17.07-.26A1.86,1.86,0,0,1,397.21,245.26Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.49,229.15v4.71a3.36,3.36,0,0,0-.61,2.16s3.31-.88,5.34.95h1.35s.14-6.37.82-7.62Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.11,229.14v4.71a3.36,3.36,0,0,1,.61,2.16s-3.31-.88-5.34,1H416s-.14-6.37-.82-7.61Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.91,115.69s-4.73,5.91-7.1,21.5a65,65,0,0,0-.69,12l2.67,79.87,13.55.39,5.07-50.5,4.7,50.84h14.13l2.18-54.33.61-31.37s-.31-18.6-8.23-29.06l-5.42-5-16.78,4.47Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.9,66.79s-2.38-1.09-2.47-6.49c0,0-.28-.82.55-6.48,0,0,.91-4.66,1.46-7.86,0,0,.91-7.22,7.86-9a17.68,17.68,0,0,1,11.2.47,8.47,8.47,0,0,1,3.15,2.23c1.56,1.76,3.71,5.22,4.11,11.1V62.41s.55,3.38-2.2,4.75a8,8,0,0,0,.19-2.29s-1.19,3.29-3.57,1.92a3.72,3.72,0,0,1-2.46.37l-10.65-.37a12.46,12.46,0,0,0-5.17-.14,1.27,1.27,0,0,1-1.19-.4,4.79,4.79,0,0,1-1.15-2.14A8.18,8.18,0,0,0,393.9,66.79Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.93,56.16c0,.56,0,1.12,0,1.68s0,1.1.06,1.65.05,1.11.11,1.65a9.19,9.19,0,0,0,.31,1.63,4.7,4.7,0,0,1-.58-1.58,9.63,9.63,0,0,1-.2-1.68A13,13,0,0,1,392.93,56.16Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.78,66.18c.09-.42.12-.83.17-1.25l.12-1.26c0-.42.07-.84.12-1.27s.1-.84.19-1.26a11.54,11.54,0,0,1,.05,2.56,10.82,10.82,0,0,1-.2,1.27A4,4,0,0,1,413.78,66.18Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.76,
    y: 56.16,
    width: 0.49,
    height: 4.97,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 396.95,
    cy: 62.05,
    rx: 0.87,
    ry: 1.61,
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.82,64.38v4.08l-5.36,3.59-5-3.72V64.69a7.44,7.44,0,0,0,5,2.1A7.6,7.6,0,0,0,411.82,64.38Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.38,71.15h0l-5.57,5.39-2.35-3.91L404,76.54l-5.39-5.71L400,68.9a1,1,0,0,1,1.48-.57l5,3.72,5.36-3.59C412.64,67.9,414.38,71.15,414.38,71.15Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.7,115.72a23,23,0,0,0-3.31,4.86c-.83,2.12-4.19,2.38-4.19,2.38l-1.4,1a.47.47,0,0,1-.68-.15l-4-6.78a.87.87,0,0,1,.08-1l.37-.45a34.9,34.9,0,0,1,.92-4.35,4.38,4.38,0,0,0,.15-1.53,2.67,2.67,0,0,1,.45-1.55,4.41,4.41,0,0,0-.1-1.32.35.35,0,0,0-.67,0,20.1,20.1,0,0,1-2.88,6.62,3.47,3.47,0,0,1-2.88,1.58,15.32,15.32,0,0,1-4-.69,3.43,3.43,0,0,0-1.35-.12c-8.55.9-22.72,1.47-22.72,1.47l-.51.18c.17,1-.52,1.29-.52,1.29l-4.32,2.41a5.18,5.18,0,0,1-5.67,0L377.79,118c-2.07-.94-2.16-5.17-2.16-5.17-.77-8.44,4.48-27.39,4.48-27.39a11.74,11.74,0,0,1,8.1-10.26l10.4-4.3L404,76.54l2.46-3.91,2.35,3.91,5.57-5.39h0l11.9,5.39c6.31,2.39,8.49,11.95,8.49,11.95,4.29,7.92,5.43,20,5.43,20A11,11,0,0,1,438.7,115.72Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.15,81.74c.62,1.15,1.2,2.32,1.76,3.5s1.08,2.38,1.58,3.59.95,2.44,1.33,3.69a15.4,15.4,0,0,1,.48,1.92,5.62,5.62,0,0,1,.09,2v0q-.36,2.55-.75,5.07c-.26,1.69-.53,3.38-.82,5.06.18-1.7.37-3.4.58-5.09s.43-3.39.66-5.08h0A5.47,5.47,0,0,0,390,94.5a17.81,17.81,0,0,0-.47-1.88c-.36-1.24-.81-2.47-1.28-3.68C387.26,86.51,386.22,84.12,385.15,81.74Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.82,85.69c-.06-1-.09-1.94-.12-2.91s0-1.94,0-2.91V75.5c0-.48,0-1,0-1.46a23.74,23.74,0,0,1,.31,2.91c.06,1,.08,1.94.09,2.91s0,2,0,2.92S406.91,84.72,406.82,85.69Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.8,113.76c.45-.59.87-1.19,1.29-1.79s.82-1.22,1.2-1.84.74-1.26,1.09-1.91.65-1.31,1-2a12.07,12.07,0,0,1-.71,2.1,14.76,14.76,0,0,1-1,2A16.34,16.34,0,0,1,419.8,113.76Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.53,101.24a14.14,14.14,0,0,1,.08-4.94,15.33,15.33,0,0,1,.66-2.41l.83-2.33c.58-1.54,1.14-3.09,1.73-4.63l.89-2.31c.31-.76.61-1.53.93-2.29l-.76,2.35-.8,2.34c-.54,1.56-1.1,3.11-1.65,4.67a35.9,35.9,0,0,0-1.56,4.66,16.54,16.54,0,0,0-.35,2.43A14.43,14.43,0,0,0,425.53,101.24Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.05,107.26a7.41,7.41,0,0,1,1.09-.64c.38-.18.77-.34,1.16-.48a13,13,0,0,1,2.46-.6,13.29,13.29,0,0,1,2.52-.1c.42,0,.84.08,1.26.12s.82.16,1.23.25c-.84,0-1.66-.11-2.49-.09a20.37,20.37,0,0,0-2.47.18,20,20,0,0,0-2.42.5A15.28,15.28,0,0,0,427.05,107.26Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.35,115.86A38.08,38.08,0,0,1,429,119a40.19,40.19,0,0,1,2.33,3.31,36.44,36.44,0,0,1-2.61-3.09A38.56,38.56,0,0,1,426.35,115.86Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "429.12 123.81 427.56 125.4 427.28 125.68 426.75 126.21 426.5 126.47 426.03 126.94 425.94 127.04 425.85 127.25 423.81 132.44 419.13 124.04 421.89 122.37 422.07 122.26 422.17 122.13 422.87 121.15 423.14 120.76 425.42 117.58 429.12 123.81",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.14,123.94l-.3.2a12.71,12.71,0,0,1-.95-1.77l.18-.11.1-.13A14,14,0,0,0,423.14,123.94Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426,126.94l-.09.1-.09.21a9.25,9.25,0,0,1-1.65-1.49l.28-.23A9.21,9.21,0,0,0,426,126.94Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.24,
    cy: 124.35,
    r: 0.5,
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.24,
    cy: 125.44,
    r: 0.5,
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.67,123.81a8.22,8.22,0,0,0,2.08,2.4l-.25.26c-1.7-1-3.34-4.65-3.63-5.32l.27-.39a8.66,8.66,0,0,0,4.41,4.64l-.27.28A6.94,6.94,0,0,1,424.67,123.81Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.72,117.58a32.63,32.63,0,0,0,3.67.6c.62.08,1.24.12,1.85.18l1.86.13q3.72.2,7.44.07c2.48,0,5-.23,7.43-.41l3.71-.35,3.71-.42c-1.23.21-2.46.4-3.69.59s-2.46.32-3.7.45l-1.86.18c-.62.06-1.24.11-1.86.14l-1.86.11-1.87.07a74.5,74.5,0,0,1-7.47-.16l-1.86-.17c-.62-.08-1.23-.14-1.85-.24A26.6,26.6,0,0,1,391.72,117.58Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.94,
    cy: 116.82,
    r: 0.96
  }), /*#__PURE__*/React.createElement("path", {
    d: "M417.48,121c.67,1,1.3,2.11,1.94,3.18s1.24,2.15,1.85,3.23,1.2,2.18,1.78,3.28l.87,1.65c.27.56.56,1.11.83,1.67-.34-.52-.66-1.06-1-1.59l-.95-1.6c-.64-1.07-1.25-2.15-1.86-3.23s-1.2-2.17-1.78-3.27S418,122.1,417.48,121Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12,120.52a20.4,20.4,0,0,1-.91,3.43,30.43,30.43,0,0,1-1.37,3.29,33.62,33.62,0,0,1-1.72,3.11c-.31.5-.65,1-1,1.48s-.7.95-1.06,1.42c.61-1,1.23-2,1.8-3l.43-.78.41-.78c.28-.51.54-1,.8-1.57.51-1.06,1-2.14,1.43-3.22.22-.55.43-1.1.62-1.66S393,121.09,393.12,120.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.94,139.89c.09,3.07.14,6.13.19,9.2l.09,9.2v9.2l0,4.6-.06,4.6-.11-4.6-.08-4.6-.09-9.2v-9.2C405.86,146,405.88,143,405.94,139.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.5,243.39c0,.09-.05.18-.07.26a1.07,1.07,0,0,1-.28.42c-.79.75-4.09,3.69-6.73,3.37h-5.67a.65.65,0,0,1-.62-.44c-.23-.74-.35-2.31,1.75-4a51.31,51.31,0,0,0,5-7s3.25-1,5.34.95h1.35S398.05,241.27,397.5,243.39Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,238.28a6.17,6.17,0,0,1,1.21-.16,7.08,7.08,0,0,1,1.22.07,5.56,5.56,0,0,1,1.19.34,2.72,2.72,0,0,1,1,.72,5.34,5.34,0,0,0-1.09-.45,7.35,7.35,0,0,0-1.15-.25C391.61,238.42,390.82,238.37,390,238.28Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.59,240.11a5.41,5.41,0,0,1,1.2-.16A7.08,7.08,0,0,1,391,240a4.91,4.91,0,0,1,1.19.34,2.72,2.72,0,0,1,1,.72,5.12,5.12,0,0,0-1.09-.45,7.49,7.49,0,0,0-1.14-.25C390.18,240.25,389.4,240.2,388.59,240.11Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.1,243.38c0,.09,0,.18.07.26a1.07,1.07,0,0,0,.28.42c.79.75,4.09,3.69,6.73,3.38h5.67a.65.65,0,0,0,.62-.45c.23-.74.35-2.31-1.75-4a51.31,51.31,0,0,1-5-7s-3.25-1-5.34,1H416S415.55,241.26,416.1,243.38Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.39,245.25l2.33,1.94a8,8,0,0,0,3.61,1.16h6.37c1.31,0,.77-1.36.77-1.36a.65.65,0,0,1-.62.45h-5.67c-2.64.31-5.94-2.63-6.73-3.38a1.07,1.07,0,0,1-.28-.42c0-.08-.05-.17-.07-.26A1.84,1.84,0,0,0,416.39,245.25Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M423.59,238.28c-.81.08-1.6.14-2.37.26a10.66,10.66,0,0,0-1.15.25,5.34,5.34,0,0,0-1.09.45,2.72,2.72,0,0,1,1-.72,5.56,5.56,0,0,1,1.19-.34,7.08,7.08,0,0,1,1.22-.07A5.52,5.52,0,0,1,423.59,238.28Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425,240.11c-.81.08-1.59.13-2.37.26a8.92,8.92,0,0,0-1.14.25,5.12,5.12,0,0,0-1.09.45,2.72,2.72,0,0,1,1-.72,5.4,5.4,0,0,1,1.19-.34,7.08,7.08,0,0,1,1.22-.07A5.43,5.43,0,0,1,425,240.11Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 394.32,
    y: 87.19,
    width: 21.72,
    height: 27.55,
    rx: 2.9,
    transform: "translate(-11.7 77.02) rotate(-10.71)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.95,
    y: 88.38,
    width: 19.73,
    height: 0.36,
    transform: "translate(-9.46 77.09) rotate(-10.81)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 403.19,
    cy: 91.61,
    rx: 2.73,
    ry: 1.3,
    transform: "translate(-9.74 112.71) rotate(-15.73)",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.93,65.17c-2.85,5.34-9.5,3.16-9.5,3.16V63.82Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.92,53.08c0,4.69-1.63,8.83-4.1,11.3a7.6,7.6,0,0,1-5.36,2.41,7.44,7.44,0,0,1-5-2.1C398.77,62.27,397,58,397,53.08c0-7.57,4.24-13.7,9.46-13.7S415.92,45.51,415.92,53.08Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397.44,
    cy: 53.82,
    rx: 2.19,
    ry: 3.02,
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M395.82,51.78a28,28,0,0,0,8.61-7s-1,3-2.74,4.15a8.48,8.48,0,0,0,6.16-7.2s4.75.08,5.64,6.91l.81,12.08,4.09-3.47-4.9-17.9-8.69-1.62-9.55,8.46Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.71,49.25c.78-.56,1.53-1.14,2.26-1.75s1.46-1.22,2.15-1.87,1.38-1.3,2-2,1.29-1.39,1.94-2.1c-.27.4-.54.79-.83,1.18s-.59.75-.9,1.11a26,26,0,0,1-2,2.07,24.25,24.25,0,0,1-2.23,1.82c-.38.28-.78.56-1.18.82S397.14,49,396.71,49.25Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.46,42a3.92,3.92,0,0,1-.53,1.2,4,4,0,0,1-.83,1,3.92,3.92,0,0,1,.53-1.2A4,4,0,0,1,406.46,42Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.26,41a5.07,5.07,0,0,1,1.24.43,6.62,6.62,0,0,1,2.83,2.71,8.57,8.57,0,0,1,.89,2.48c.09.43.11.87.17,1.3s0,.88,0,1.31c-.07-.43-.1-.86-.17-1.29s-.14-.85-.26-1.26a10.71,10.71,0,0,0-.4-1.21,8.51,8.51,0,0,0-.53-1.15,8.19,8.19,0,0,0-1.59-2A7,7,0,0,0,409.26,41Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.85,41.76a13.74,13.74,0,0,1-.18-2.48,13.91,13.91,0,0,1,.18-2.49,16,16,0,0,1,.18,2.49A15.83,15.83,0,0,1,407.85,41.76Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.8,107.7l6.36-1a1.32,1.32,0,0,0,1-.76,9.82,9.82,0,0,1,3.05-4s4.7-3.18,5.56-2c0,0,.43.43-1.77,1.89l-1.9,1.84a17.12,17.12,0,0,0,5.14-1.35s3.12-2.5,4.15-1.89c0,0,.86.49-1.52,2.14l-2.36,1.88a.08.08,0,0,0,.08.14l3.36-1.28a15,15,0,0,0,1.54-.68c.77-.4,1.95-.77,2.33-.13,0,0,.43.62-.74,1.17,0,0,1.35.55.13,1.52,0,0-2.39,1.76-3,2.05,0,0,1.53,0,.92,1.19,0,0-1.22,1.23-5.87,2.14L399.06,112a2.89,2.89,0,0,0-.77.25l-6.54,3Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "391.92 107.36 393.46 114.47 395.64 113.46 394.36 106.97 391.92 107.36",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.92,115.89,389.61,107l-3.54-.73.55,9.06s1,1.65,1.09,1.84a13.84,13.84,0,0,0,2.36.78Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.61,117.38c-.23-.75-.42-1.52-.61-2.28s-.35-1.53-.51-2.3-.31-1.54-.44-2.32l-.19-1.16c-.05-.39-.11-.78-.15-1.17.12.38.22.76.33,1.13l.28,1.15c.2.76.36,1.53.52,2.3s.31,1.54.43,2.31S389.53,116.6,389.61,117.38Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389.31,107.29a7,7,0,0,1-2.9.53,5.4,5.4,0,0,1-1.46-.28,10,10,0,0,0-1.41-.28,17.43,17.43,0,0,0-2.89-.11,9.78,9.78,0,0,0-1.43.16,7.77,7.77,0,0,0-1.41.39,7.3,7.3,0,0,1,2.82-.83,13.23,13.23,0,0,1,2.95,0,8.8,8.8,0,0,1,1.46.31l.7.21a5.25,5.25,0,0,0,.69.13,7.7,7.7,0,0,0,1.44,0A9,9,0,0,0,389.31,107.29Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.75,105.21a14.23,14.23,0,0,1,3,.6,12.22,12.22,0,0,1,1.46.56,4,4,0,0,1,1.28.89,7.52,7.52,0,0,0-1.39-.63c-.48-.16-1-.33-1.45-.47C380.71,105.85,379.73,105.57,378.75,105.21Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 393.99,
    cy: 110.38,
    r: 2.08,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.06,103.69a17.06,17.06,0,0,1-2.71,1.51,16.63,16.63,0,0,1-2.92,1Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.19,107.26a7.11,7.11,0,0,1-1.43.66,4.8,4.8,0,0,1-1.55.31A16.22,16.22,0,0,1,411.19,107.26Z",
    fill: "#f9aac0"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M575.78,157.79l-177.93-4.7s-15.06-2.83-16.94,17.41l-4.24,187.82s-6.36.28-9.55-1.5a2.79,2.79,0,0,0-3.84,1.12c-3.27,6.11-8,19.29,4.39,29.6A30.59,30.59,0,0,0,388,394.38l158.12-3.76s15.55-.1,13.31-21.36l.81-183.13a42.58,42.58,0,0,1,3-15.86C565.55,164.62,569.43,158.73,575.78,157.79Z",
    fill: "#fddfd2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M575.78,157.79s7.07,2.83,4.71,22.6H560.62S562.13,160.62,575.78,157.79Z",
    fill: "#fddfd2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M560.62,180.39h12.92a31.15,31.15,0,0,1,2.24-22.6S564,158.54,560.62,180.39Z",
    fill: "#fcd6ca"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M376.67,358.32l158.54,2.86s-13.86,28.09,19,26.27c0,0-26.49-13.62-11.4-33.84l-166.12-1.69Z",
    fill: "#fcd6ca"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "413.54 163.01 536.67 163.01 536.67 321.52 410.32 321.52 413.54 163.01",
    fill: "#fff"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.52,234.17s4.07,2.45,12.27,0l4.94,91-22.48.23Z",
    fill: "#e6e7e8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.62,232.08A18,18,0,0,1,465,233.37a1.91,1.91,0,0,1-1.06-1.72V213.13c2.44,3.17,5.56,5.07,9,5.07,4.07,0,7.74-2.72,10.33-7.08-.5,6.07.76,15.68,1.24,19A2,2,0,0,1,483.62,232.08Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.9,325.42c.51-1.39.24-19,.08-27.13q-.06-3.12-.42-6.22c-.7-6.05-.62-17.94-.62-17.94l.89-16,.11-23.28a29.47,29.47,0,0,0,.35-3.07,4.56,4.56,0,0,0-1.56-3.72l-3.31-2.91-6.5,1.62s-8,1.25-19.17,6.62a9.77,9.77,0,0,0-3.1,2.34,25.91,25.91,0,0,0-4.8,8.38s-1.86,3.45-6.35,24.71l-3.75,16.16s-8.57,25.9,15.38,25.28a11,11,0,0,1-5.83-11.05c.19-1.69,1.75-3.07,3.24-3.88s3.93-.73,7.32-.28l-2.76-3.19a.79.79,0,0,1-.15-.77l4.19-12.92,1.77,25.9-4.33,21.39Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.72,231.51s-.67-2,2.07-4c0,0,3.66-2.29,4.84-4.24l4.52,3.48s21.05,4.51,23.7,10.74c0,0,3.18,1.86,8,23.07l4.64,20.55s7.55,22.68-4.78,26.52c0,0-5.83,4.11-9.68,2.39a10.47,10.47,0,0,0,5.7-8.72,6.23,6.23,0,0,0-3.65-6.06,13.1,13.1,0,0,0-6.16-.87L508.1,293a3,3,0,0,0,.64-2.7c-.73-2.76-2.36-8.56-3.84-11.33,0,0-1.86,37.52,2.38,45.35l-28.43,1.1.29-28.59s-1.29-32.76-.29-44.5C478.85,252.33,479.44,236.87,477.72,231.51Z",
    fill: "#1A1A1A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.14,305a14.87,14.87,0,0,1-1-2.42,13.06,13.06,0,0,1-.52-2.56,10.46,10.46,0,0,1,0-2.62,7.68,7.68,0,0,1,.83-2.5c.11-.19.22-.38.34-.57l.4-.53c.14-.17.29-.33.44-.49l.11-.12L427,293l.25-.22a8.84,8.84,0,0,1,2.23-1.38,10.59,10.59,0,0,1,1.22-.47l.15-.05.16-.05.32-.08.63-.17,1.28-.23,1.29-.15a17.58,17.58,0,0,0-4.95,1.42A9.22,9.22,0,0,0,427.4,293l-.24.22-.12.1-.1.12-.43.47-.38.51-.32.55a7.49,7.49,0,0,0-.81,2.4,10.37,10.37,0,0,0-.1,2.55,14.48,14.48,0,0,0,.42,2.54A16.51,16.51,0,0,0,426.14,305Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.72,290.24q.63.06,1.26.18c.42.09.83.18,1.24.3a11.64,11.64,0,0,1,2.39.94,9.75,9.75,0,0,1,2.08,1.52,10,10,0,0,1,1.58,2,9.18,9.18,0,0,1,1.21,5,8.68,8.68,0,0,1-1.67,4.78l.16-.27.15-.28c.11-.18.19-.38.29-.57s.17-.39.24-.58.15-.4.2-.6a8.79,8.79,0,0,0,.39-2.48,10.63,10.63,0,0,0-.06-1.26c0-.2,0-.41-.1-.62L522,298l-.08-.31a9.12,9.12,0,0,0-.94-2.31,9.43,9.43,0,0,0-3.51-3.51,12.53,12.53,0,0,0-2.31-1A15.82,15.82,0,0,0,512.72,290.24Z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.55,297.37s-3.53-2.8-2-5.07c0,0,1.93-1.44,4.78,1.65A9.35,9.35,0,0,0,465.55,297.37Z",
    fill: "#f9acc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.23,218.2l.43,5.38a1.8,1.8,0,0,1-.61,1.49,37.06,37.06,0,0,1-3.26,2.42s3.27,1.15,5.39,5.74c0,0,1.68,3.71,2.3.71l1.95-8.4s.35-.62-1.33-3.27C488.1,222.27,486.23,218.1,483.23,218.2Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M467.51,227.84s-2.48-.35-4.69,4l-1.54,3.23c-.17.31-.5.23-.82.1s-.71-.72-1.08-2.43l-1.66-6.85a2,2,0,0,1,0-1.22c.64-1.76,2.7-6.61,6.17-6.45V224a1.41,1.41,0,0,0,.48,1.07Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.94,213.13v5.07a28.66,28.66,0,0,0,19.29,0c-.05-.78-.09-1.58-.11-2.4a52.31,52.31,0,0,1,.11-5.32Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.09,195.66a30.7,30.7,0,0,1-3.86,15.45h0c-2.59,4.36-6.26,7.08-10.33,7.08-3.4,0-6.52-1.9-9-5.07-3.19-4.13-5.23-10.43-5.23-17.47,0-12.45,6.35-22.54,14.19-22.54S487.09,183.21,487.09,195.66Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 487.09,
    cy: 198.81,
    rx: 5.16,
    ry: 3.11,
    transform: "translate(191.39 633.95) rotate(-78)",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 458.71,
    cy: 199.95,
    rx: 3.11,
    ry: 5.16,
    transform: "translate(-39.21 150.28) rotate(-17.86)",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.13,195s-8.35-19.79,10.81-23.89c0,0,8.68-2.13,13.54,3.49a8.92,8.92,0,0,1,6.83,8.26,10.7,10.7,0,0,1,0,6s-1.52,3.3-.73,4.88a2.75,2.75,0,0,0-1.37.58s-2.53-9.44-5-10.23a9.47,9.47,0,0,0-6.19.09s-6.19,1.76-10.78,1.59c0,0-4.16.26-4.42,3.36,0,0,.23,4.4-.84,6.17A2,2,0,0,0,457.13,195Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.43,297.6c3.24,1.61,11.18,3.39,11.18,3.39,4.71,1.18,6.43-2.55,6.43-2.55,1.49-3.51,3.58-4.83,4.78-5.31a1.27,1.27,0,0,1,1.58.52c1.54,2.57-1.61,5-1.61,5-2,4.61,12.16,10.49,12.16,10.49a10.51,10.51,0,0,0,4.74.18,3.3,3.3,0,0,0,1.76-1,7.06,7.06,0,0,1,4-2.31,1.25,1.25,0,0,1,1.52,1.35c-.22,2.18-4,4.9-4,4.9-3.93,5.49-7.95,4.31-7.95,4.31a21.5,21.5,0,0,0-4.3-1c-2.94.1-6-2.94-6-2.94-10.4-.2-11.28-1.77-11.28-1.77-5.89,1.18-24.25-.67-24.25-.67a11.32,11.32,0,0,1-6.2-8.89,5.76,5.76,0,0,1,2-5.12c1.6-1.27,4.34-2.29,8.92-1.2Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M475.32,312.62a18.12,18.12,0,0,0,1.68.77c.29.12.57.24.86.34s.58.21.87.29a14.13,14.13,0,0,0,3.58.61,8.54,8.54,0,0,0,3.5-.69l.82-.4.74-.53c.13-.09.26-.16.38-.26l.33-.32c.22-.22.45-.43.68-.64a7.48,7.48,0,0,1-6.46,3.35,11.29,11.29,0,0,1-3.69-.75A13.2,13.2,0,0,1,475.32,312.62Z",
    fill: "#f9acc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.58,297.53a10.16,10.16,0,0,0-4.16,2.7s-5.52,3.33-4.35,11c0,0-.69,4.7,3.11,4.17,0,0,2,3.56,4.6-2.81,0,0,1,3.19,3.89,0,0,0,4.49-3.43,7.28-3.49,0,0,4.66,1.16,6.46-.76a7,7,0,0,1,4-2.35s1.57-.11,1.49,1.42c0,0,.14,1.3-3.05,4.05,0,0,14.81,0,20.11-1.49a10.12,10.12,0,0,0,5.66-8.84,6.15,6.15,0,0,0-3.48-5.91,12.34,12.34,0,0,0-6.29-.9s-5.9,2.52-10.34,4.84c0,0-12.77,6.23-19.42-.34A5.54,5.54,0,0,0,471.58,297.53Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.07,310.92a13.4,13.4,0,0,1,1.16-3.11,15.05,15.05,0,0,1,1.84-2.78,12.51,12.51,0,0,1,2.45-2.26,10.83,10.83,0,0,1,3-1.47,16.38,16.38,0,0,0-1.41.84l-.68.44-.64.51a16.45,16.45,0,0,0-2.3,2.27,21.58,21.58,0,0,0-1.89,2.65A25,25,0,0,0,463.07,310.92Z",
    fill: "#f9acc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M465.85,314.65a10.62,10.62,0,0,1,.54-3.53,11.91,11.91,0,0,1,1.59-3.24,11.39,11.39,0,0,1,2.48-2.61,13.45,13.45,0,0,1,1.49-1c.52-.29,1.08-.52,1.62-.76a19,19,0,0,0-2.85,2.07,13.64,13.64,0,0,0-2.31,2.61,13.92,13.92,0,0,0-1.64,3.07A15.82,15.82,0,0,0,465.85,314.65Z",
    fill: "#f9acc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.78,312.62a14.47,14.47,0,0,1,1.53-2.49,15.5,15.5,0,0,1,1.95-2.18,11.66,11.66,0,0,1,2.39-1.73,7.49,7.49,0,0,1,2.79-.86,11.12,11.12,0,0,0-2.59,1.2,17.43,17.43,0,0,0-2.24,1.77,27.69,27.69,0,0,0-2,2.05C472,311.1,471.37,311.85,470.78,312.62Z",
    fill: "#f9acc2"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.91,80.3a.21.21,0,0,0-.1.4c4.71,2.37,25.65,17.43,24.4,97.41V457.47h183l4.23-315.25S356.31,95.08,331,80.3Z",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.91,80.3s-17.36-.62-17.66,23.85c0,0-2.11,21.51,23.26,21.15H161S157.57,93,139.91,80.3Z",
    fill: "#fddfd2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.59,81a48,48,0,0,1,9.92,44.31H161s-4.93-34.72-21.08-45A11.89,11.89,0,0,0,135.59,81Z",
    fill: "#fcd6ca"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 182.82,
    y: 148.54,
    width: 148.66,
    height: 181.91,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M266,254.53l7.69,5.76s26.61,4,35.51,16.77c0,0,12.24,12.72,29.41,46.74a28.2,28.2,0,0,1-5.88,24.73,140.35,140.35,0,0,1-33.23,32.39,1.24,1.24,0,0,1-.93.21c-1.73-.34-7.29-2.21-10.67-12.57L314.38,334l-19.32-21.23s-8.74,51-8.59,71.79c0,0-44.58,9.22-77.48-1.59,0,0-.72-102.3,0-114.79,0,0,14.92-7.63,26.45-7.63l8.13-5.29Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.7,260.29s-4.08,14.7-15.37,18.2l-7-9.1-7.92,7.51s-7.82-7.15-8-16.37l8.13-5.29s1.87,9.92,8.16,11.65c0,0,9.08-.39,14.28-12.36Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.3,282.49l5.16-5.13-6.12-8-7.16,6.79,3.31,5.94s-9.82,21-9.35,74.6l7.32,9.38,7.94-9.7S251.67,290.93,252.3,282.49Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209,268.16s-12,3.35-16.13,57.78l-1.81,20.73-14.18,50.85a5.44,5.44,0,0,0,1.73,5.65c2.74,2.29,7.45,5.05,13.16,3.49a5.24,5.24,0,0,0,3.34-3c2.75-6.12,10.8-24.46,13.57-35.77Z",
    fill: "#EC1C24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.19,406.79s.8,5.16-.95,9.25a5.78,5.78,0,0,0-.26,4.11c1,3.08,2.4,8.44.29,9.94,0,0-1.81,4.29-5,4.05,0,0,1.07,2.75-1.67,3.34,0,0-11.93-4.29-10.85-19.43a83.23,83.23,0,0,1,5.06-15.76A14.61,14.61,0,0,0,191.19,406.79Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.59,406.72a14.4,14.4,0,0,1-1.06,7.8,8.25,8.25,0,0,0-.94,4.35,25.39,25.39,0,0,0,1,6.09s0,2.15-2.58,0c0,0-1.66-.59-2.5-5.6,0,0-.73,8.11,2.5,11.45,0,0,2.39,3.24,5.61.95,0,0,3.7-1.79,1.55-10.37,0,0-.59-3.44.6-4.93a4.56,4.56,0,0,0,.93-1.59,23.55,23.55,0,0,0,.49-8.08A20.73,20.73,0,0,1,185.59,406.72Z",
    fill: "#f9acc2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.38,232.19a23.32,23.32,0,0,0,13,15.72,17.5,17.5,0,0,0,6.81,1.47,31.42,31.42,0,0,0,29-19.79,48.48,48.48,0,0,0,3-19.05l-6.54-24.38L228,184.6l.16,18.5C227.22,222,230.38,232.19,230.38,232.19Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.46,193.84s-19-8.34-57.31-4.51c0,0,.45,10.83-2,13.76,0,0-2.26-1.58-1.81-23.91,0,0,0-11.28,5-16,0,0-1.81,5-1.81,7,0,0,5.42-16,24.52-8.79,0,0,24.89,6.09,35.27,23.23l2.48,5.19L289,188s2.93,5.41,2.7,8.12C291.74,196.1,288.81,190.23,287.46,193.84Z",
    fill: "#272727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.65,181.29a21.89,21.89,0,0,0-6.33-2.47,22.72,22.72,0,0,0-6.83-.53,24.64,24.64,0,0,0-3.41.52,20.88,20.88,0,0,0-3.25,1.14,15.61,15.61,0,0,0-1.54.75l-1.46.88a10.59,10.59,0,0,0-1.37,1c-.44.36-.88.72-1.3,1.09a28.45,28.45,0,0,1,5.94-3.09,26.91,26.91,0,0,1,3.17-1,28.26,28.26,0,0,1,3.29-.45,27.73,27.73,0,0,1,6.62.31,30.28,30.28,0,0,1,3.27.73A26.06,26.06,0,0,1,285.65,181.29Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.05,173.54a17.17,17.17,0,0,0-3.25-.81,25.14,25.14,0,0,0-3.36-.19,21.14,21.14,0,0,0-6.64,1.13,22.11,22.11,0,0,0-6,3.07,26.45,26.45,0,0,0-2.61,2.11c-.81.77-1.55,1.61-2.28,2.44.88-.68,1.67-1.45,2.56-2.11a28.91,28.91,0,0,1,2.71-1.86l1.41-.85,1.47-.72a24.65,24.65,0,0,1,3-1.22,26.29,26.29,0,0,1,6.39-1.3A24.67,24.67,0,0,1,275.05,173.54Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.14,164.74a14.35,14.35,0,0,0-4.75,3.35,23.53,23.53,0,0,0-3.53,4.66,29.24,29.24,0,0,0-2.43,5.31c-.32.92-.57,1.86-.85,2.78s-.41,1.9-.57,2.85c.36-.9.66-1.81,1-2.71s.69-1.8,1.07-2.67.75-1.76,1.21-2.59l.64-1.28.72-1.23a31.84,31.84,0,0,1,3.26-4.65,21.3,21.3,0,0,1,2-2.05A13.89,13.89,0,0,1,255.14,164.74Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.07,161.35a14.4,14.4,0,0,0-3.44.94,16.64,16.64,0,0,0-3.12,1.78,15,15,0,0,0-4.61,5.53,19.24,19.24,0,0,0-1.67,7c0,1.2.06,2.39.08,3.58.21,1.18.38,2.35.61,3.51,0-1.19-.11-2.36-.17-3.53s0-2.35.18-3.5a24.25,24.25,0,0,1,.63-3.42,11.64,11.64,0,0,1,.5-1.65l.65-1.6a16.34,16.34,0,0,1,4.22-5.37A17.4,17.4,0,0,1,249.07,161.35Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.46,193.84s-1.52,15-2.59,17.32c0,0-4.71-.72-6.56,3.1,0,0-5.52-12.95-5.84-24.23C272.47,190,281.76,191.43,287.46,193.84Z",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 282.88,
    cy: 219.36,
    rx: 8.59,
    ry: 6.43,
    transform: "translate(8.79 449.61) rotate(-77.82)",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.42,247.91v5.93a6.53,6.53,0,0,0,.15,1.4c2.25,10.44,8.16,11.65,8.16,11.65,6.11-1,10.19-5.19,12.45-8.33a11.82,11.82,0,0,0,2.17-6.9v-6.85a31,31,0,0,1-16.12,4.57A17.5,17.5,0,0,1,243.42,247.91Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.35,244.81v5.57s-11.82,6.17-22.93,3.46v-5.93S253.24,252.48,266.35,244.81Z",
    fill: "#f9aac0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.11,380.19s-4.63,8.05-8.92,5.54c0,0-5.25-2.26-7.15-.71,0,0-6.32,5.6-8.11,5.6,0,0-2.51.29-1.79-2.42l6.08-5.81s-2.64-1.43-6.21,1.2c0,0-4.52,3.1-6.55.59a2,2,0,0,1,0-2.38s-3,.73-2.5-1.61c0,0,2-5.33,14.07-6.86a11.83,11.83,0,0,0-8.47-.95s-4.05,1.31-5-1.08c0,0-1.78-2.33,4.66-3.57a9.89,9.89,0,0,1,1.63-.16,25.47,25.47,0,0,1,9.7,1.49.92.92,0,0,0-.37-1.58,3.68,3.68,0,0,1-.44-4,.6.6,0,0,1,1-.15,13.13,13.13,0,0,0,2.46,2.41,1.55,1.55,0,0,0,.95.29A6,6,0,0,1,285.6,368a1.68,1.68,0,0,0,1.12.5l1.19.07S290.25,376.77,296.11,380.19Z",
    fill: "#ffb8ca"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.46,381.8a9.12,9.12,0,0,1,2.39-1.79,13.63,13.63,0,0,1,2.76-1.15,12.63,12.63,0,0,1,5.92-.32c-1,.24-1.93.4-2.86.63s-1.86.44-2.77.71-1.81.56-2.72.88S264.38,381.42,263.46,381.8Z",
    fill: "#f9acc2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,347.93H194.89a.53.53,0,0,1,0-1.06H319.42a.53.53,0,0,1,0,1.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,361.71H194.89a.53.53,0,0,1,0-1.06H319.42a.53.53,0,1,1,0,1.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,377.27H194.89a.53.53,0,0,1,0-1.06H319.42a.53.53,0,1,1,0,1.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,391.05H194.89a.53.53,0,0,1,0-1.06H319.42a.53.53,0,1,1,0,1.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.42,407.06H194.89a.53.53,0,0,1,0-1.06H319.42a.53.53,0,1,1,0,1.06Z",
    fill: "#fff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 152.95,
    y: 507.29,
    width: 6.57,
    height: 125.55,
    fill: "#d6dfe4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M141.4,613.92h29.08a24.43,24.43,0,0,1,24.43,24.43v1.85a0,0,0,0,1,0,0H117a0,0,0,0,1,0,0v-1.85A24.43,24.43,0,0,1,141.4,613.92Z",
    fill: "#a5b9c5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M265.68,604.65s-15.13,19.35,3.17,27.79c0,0,31,21.79,47.37,14.2a2.42,2.42,0,0,0,1.11-3.28c-1.35-2.68-5.62-8.08-18.22-18.66l-21.47-20.05Z",
    fill: "#EC1C24"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M322.68,555.39s-6.3,17.68,13.44,11.86c0,0,34-4.66,44-13a3.18,3.18,0,0,0-1.58-5.55c-3.4-.55-9.54-.88-20.64-.37Z",
    fill: "#EC1C24"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M62.32,362.34l42,126.58a9.17,9.17,0,0,0,8.7,6.28h112.6V508a10.72,10.72,0,0,1-10.73,10.73H97a10.64,10.64,0,0,1-10.15-7.42L43.7,375.7a9,9,0,0,1,7.14-11.56Z",
    fill: "#a5b9c5"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M62.32,362.34H121a9,9,0,0,1,8.62,6.4l18.57,61.67,77.43,64.79H112.69a8.71,8.71,0,0,1-8.27-6Z",
    fill: "#d6dfe4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M326.18,518.42c-6.2-20.92-29.48-57.34-29.48-57.34-17.44-32.63-47.35-53.92-47.35-53.92l-12.46-41.24c-2-12.46-11-15.71-11-15.71l-18.62-8.08L181.84,336l-10.89.61-17.2,1s-23.34-1.81-19.26,20.84c0,0,4.53,20.85,19.48,36.47,0,0-19.43,43.24-42.71,66.25a8,8,0,0,0-.87,10.33c9.48,13.42,33.48,44.07,45.85,29.91a14.38,14.38,0,0,0,4.92,1.25l.68.07A39.82,39.82,0,0,0,176.18,501c.87-.26,1.75-.5,2.62-.73l.09,0c29.35-7.86,48.94-2.88,48.94-2.88,21.83,4.66,28.13,52.17,29.69,68.94a4.39,4.39,0,0,0,6,3.69l21.71-8.41a1.24,1.24,0,0,0,.8-1.24c-1.85-25.18-14.89-73.17-14.89-73.17L305.27,535a1.54,1.54,0,0,0,2.22.3L325.39,521A2.41,2.41,0,0,0,326.18,518.42ZM223.07,411.68,224,398l4.17,11.55Z",
    fill: "#EC1C24"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M214,410.42l-.91-6.21-5.82-62.08L181.84,336s8.26,21.52,12.74,64.34L196,416Z",
    fill: "#fff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M181.84,336s8.53,13.89,9,14.19,6.24-9.25,6.24-9.25l1.27-.78,8.95,11.24v-9.3l-7.1-3.08L187,331.77A16.83,16.83,0,0,1,181.84,336Z",
    fill: "#EC1C24"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M181.84,336s8.53,13.89,9,14.19,6.24-9.25,6.24-9.25l1.27-.78,8.95,11.24v-9.3l-7.1-3.08L187,331.77A16.83,16.83,0,0,1,181.84,336Z",
    fill: "#fff",
    opacity: 0.2
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M217.19,346.42l4.49,12.24a6,6,0,0,1-1,5.82L216.28,370s6.34,2.72,3.28,16.08l-6.45,18.13-5.82-62.09Z",
    fill: "#EC1C24"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M217.19,346.42l4.49,12.24a6,6,0,0,1-1,5.82L216.28,370s6.34,2.72,3.28,16.08l-6.45,18.13-5.82-62.09Z",
    fill: "#fff",
    opacity: 0.5
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M181.84,336l-10.89.61a56.43,56.43,0,0,1-3.25,11.18,3.82,3.82,0,0,0,1,4.39l7.82,6.89a4.31,4.31,0,0,1,.27,6.23l-2.66,2.78a3.86,3.86,0,0,0-.11,5.23c5.5,6.22,18.82,21.65,20.57,27C194.58,400.36,189.54,354.82,181.84,336Z",
    fill: "#EC1C24"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M181.84,336l-10.89.61a56.43,56.43,0,0,1-3.25,11.18,3.82,3.82,0,0,0,1,4.39l7.82,6.89a4.31,4.31,0,0,1,.27,6.23l-2.66,2.78a3.86,3.86,0,0,0-.11,5.23c5.5,6.22,18.82,21.65,20.57,27C194.58,400.36,189.54,354.82,181.84,336Z",
    fill: "#fff",
    opacity: 0.5
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M264,569.74s4.82,25.76,1.65,34.91a74.29,74.29,0,0,1,19.68,26.89,4,4,0,0,0,6.64,1.14l7.11-8S280.33,588.08,281.57,563Z",
    fill: "#ffb8ca"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M308.74,534.27s8.66,10.22,13.94,21.12c0,0,18.18,1.17,29.12,2.93a5.23,5.23,0,0,0,6.06-5.17v-4.79s-34.74-12.71-34.75-25.59Z",
    fill: "#ffb8ca"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M305.27,535l-34.16-47.84s13,47.82,14.88,73a1.24,1.24,0,0,1-1,1.29c-5,1.11-26.55,4.84-25.48-13.36,0,0,7.51-63.76-39.57-60.75l-11.31,1.73a48.78,48.78,0,0,0-14.86,4.83,102.18,102.18,0,0,1-14.92,6.29l-.09,0a46.31,46.31,0,0,1-15.55,2.58c-.5,0-1,0-1.41-.08l-.68-.07a18.52,18.52,0,0,1-4.92-1.25s43.11-28.55,65.41-43.26a24.77,24.77,0,0,1,13.64-4.09h8.56a27.22,27.22,0,0,1,22.88,12.48c10.52,16.34,28.68,43.94,36.85,52.71,0,0,4.28,8.06,21.81,1.72l-17.9,14.31A1.54,1.54,0,0,1,305.27,535Z",
    opacity: 0.2
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M154,394.92l30.31,44.86,42.82-10.2.32,2.46a3.47,3.47,0,0,1-3,3.88l-40.15,5.22L152.53,398Z",
    opacity: 0.2
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M297.61,406.7s-5.28-1.94-15.78,5.26l-3.71,18.45,5.74-3.51Z",
    fill: "#f9aac0"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M318.05,380.5h68.49a2.81,2.81,0,0,1,2.39,4.3l-35.36,56.34H280.62Z",
    fill: "#1A1A1A"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 338.87,
    cy: 414.73,
    rx: 6.46,
    ry: 4.94,
    transform: "translate(-196.66 421.52) rotate(-51.48)",
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 235.71,
    y: 441.14,
    width: 223.19,
    height: 11.09,
    fill: "#a5b9c5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 359.46,
    y: 452.23,
    width: 6.57,
    height: 196.02,
    fill: "#272727"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 434.68,
    y: 452.23,
    width: 6.57,
    height: 196.02,
    fill: "#272727"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 247.9,
    y: 452.23,
    width: 6.57,
    height: 196.02,
    fill: "#272727"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 173.94,
    y: 452.23,
    width: 6.57,
    height: 196.02,
    fill: "#272727"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 180.26,
    y: 398.01,
    width: 21.18,
    height: 2.39,
    fill: "#008fa3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 180.26,
    y: 398.01,
    width: 21.18,
    height: 2.39,
    opacity: 0.2
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M197.3,398h-.79v-7.7a3.22,3.22,0,0,1,1.43-2.68l6.31-4.25.45.65-6.32,4.26a2.44,2.44,0,0,0-1.08,2Z",
    fill: "#272727"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "179.52 402.75 181.84 441.14 201.44 441.14 203.02 402.75 179.52 402.75",
    fill: "#e6e7e8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 152.95,
    y: 441.14,
    width: 82.76,
    height: 11.09,
    fill: "#d6dfe4"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M225.44,314.67a40.87,40.87,0,0,0,1.15,19.93,23.64,23.64,0,0,1,1,4.86c.39,3.55.53,8.82-1.72,10.75L200.19,339l4.66-9.19S219.43,331.09,225.44,314.67Z",
    fill: "#272727"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 205.84,
    cy: 303.77,
    rx: 21.54,
    ry: 26.33,
    fill: "#ffb8ca"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M134.49,350.21s-3.93-16.46,14.8-32.55c0,0-8.46,4.46-16.61,2,0,0,31.11-6.34,39.57-23.86,0,0,9.36-23.26,35.64-21.45,0,0,21.21-3,19.06,24.16,0,0-9.09-6.64-13.32-17.21,0,0-10.32,17.68-29.33,22.43,0,0-1,10.41,7.51,20,0,0-3.63,9.33-10,12.28l-28.09,1.58S136.53,336.77,134.49,350.21Z",
    fill: "#272727"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M200.19,339,197.07,341l-10-9.19a29.73,29.73,0,0,0,4.77-8s5.51,6.17,13.06,6.36Z",
    fill: "#ffb8ca"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M204.87,330.1a17.11,17.11,0,0,1-9.91-3.64l-5,8-3-2.72a33.32,33.32,0,0,0,4.77-8,28.68,28.68,0,0,1-7.51-20,14.34,14.34,0,0,0,3.66-1.08s3.37,18.29,16.91,27.41",
    fill: "#f9aac0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.54,
    cy: 309.39,
    r: 8.27,
    fill: "#ffb8ca"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M285.86,419.61a17.76,17.76,0,0,1-4,10.36,8.26,8.26,0,0,1-2.44.45c-7.68.36-20-7.13-25.84-11a7.22,7.22,0,0,0-7-.53l-19.17,8.93a23.43,23.43,0,0,0-.7-4.8h0a94.45,94.45,0,0,0-3.6-11.32l16.35-6.84c25.44-6.45,39,3.59,43.95,8.59A8.37,8.37,0,0,1,285.86,419.61Z",
    fill: "#ffb8ca"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M281.83,430l-2.44.45c-7.68.36-20-7.13-25.84-11a7.22,7.22,0,0,0-7-.53l-19.17,8.93a23.43,23.43,0,0,0-.7-4.8h0l26.37-9.45a2.58,2.58,0,0,1,2.54.47C259.74,417.54,274.31,429.47,281.83,430Z",
    fill: "#f9aac0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M267.48,410.33a37.3,37.3,0,0,1,18.38,9.28,126.6,126.6,0,0,0-18.38-9.28Z",
    fill: "#f9aac0"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M267.48,415a46.34,46.34,0,0,1,17.44,9.48c-5.56-3-11.82-6.57-17.44-9.48Z",
    fill: "#f9aac0"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M319.24,384.28l-36.36,56.86H235.71v-5.91a2.9,2.9,0,0,1,2.93-2.91l38.56.19a4.76,4.76,0,0,0,3.94-2.05l33.79-49a2.59,2.59,0,0,1,4.12-.19h0A2.59,2.59,0,0,1,319.24,384.28Z",
    fill: "#1A1A1A"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M319.24,384.28l-36.36,56.86H235.71v-5.91a2.9,2.9,0,0,1,2.93-2.91l38.56.19a4.76,4.76,0,0,0,3.94-2.05l33.79-49a2.59,2.59,0,0,1,4.12-.19h0A2.59,2.59,0,0,1,319.24,384.28Z",
    opacity: 0.2
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 177.22,
    y: 400.36,
    width: 27.25,
    height: 2.39,
    fill: "#008fa3"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M478.78,604.07S481,588,491.23,586.26s7.16-9.52,9.84-12.52,9.65,5.85,3.68,14.45-1.1,5.89-3.68,13.85S477.83,617.37,478.78,604.07Z",
    fill: "#008fa3"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M478.78,604.07S481,588,491.23,586.26s7.16-9.52,9.84-12.52,9.65,5.85,3.68,14.45-1.1,5.89-3.68,13.85S477.83,617.37,478.78,604.07Z",
    fill: "#fff",
    opacity: 0.2,
    style: {
      isolation: "isolate"
    }
  }), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M480.53,614.31h-.23a.77.77,0,0,1-.51-1c0-.18,4.95-17.52-3.23-42.63A110.81,110.81,0,0,0,466.9,550c-6.93-12.35-13-23-7.1-44.32,1.73-6.59,3.75-12.75,5.64-18.73,6.93-22,12.39-39.35,3.92-54.3a.78.78,0,0,1,.28-1.07h0a.78.78,0,0,1,1.06.3c8.82,15.59,3.25,33.2-3.78,55.55-1.89,6-3.81,12.12-5.63,18.67-5.7,20.68-.12,30.61,6.93,43.15A112.22,112.22,0,0,1,478,570.22c8.33,25.62,3.29,43.31,3.22,43.55A.77.77,0,0,1,480.53,614.31Z",
    fill: "#008fa3"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M485.12,611.28s6.63-10-2.94-15.14-11.49-1-17.41-4.7-10.4-12.66-11.44-6.93,5.84,9,3.47,11.63S472.86,615.78,485.12,611.28Z",
    fill: "#008fa3"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M474.17,440.05s3.24-20.42-11.34-18.47S467.24,439.08,474.17,440.05Z",
    fill: "#008fa3"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M464,457s-7.19-16.94-16.89-11.53S453.75,459,464,457Z",
    fill: "#008fa3"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M481.69,455.71s-3.84-13.86,7.05-15.89S496.69,450.91,481.69,455.71Z",
    fill: "#008fa3"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M479.09,485.59s12.54-15.47,19.4-6.6S489.35,492.55,479.09,485.59Z",
    fill: "#008fa3"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M452.76,487.49s-6.28-21.27-17-12.52S442.8,491.34,452.76,487.49Z",
    fill: "#008fa3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M447.41,520.28s5.2-23.36-10.69-18.24S435.06,516.84,447.41,520.28Z",
    fill: "#008fa3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M473.62,524.06s11.1-18.41,22.41-15S501.4,530,473.62,524.06Z",
    fill: "#008fa3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M467,561.91s-15.92-24.06-24.89-13.62S452.3,569,467,561.91Z",
    fill: "#008fa3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M483.75,557.72s-6.37-19.65,5.46-19.92S500,550.27,483.75,557.72Z",
    fill: "#008fa3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M474.1,440.05s3.24-20.42-11.35-18.47S467.17,439.08,474.1,440.05Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.89,457s-7.18-16.94-16.88-11.53S453.67,459,463.89,457Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.61,455.71s-3.84-13.86,7.05-15.89S496.62,450.91,481.61,455.71Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479,485.59s12.54-15.47,19.4-6.6S489.27,492.55,479,485.59Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.69,487.49s-6.29-21.27-17-12.52S442.73,491.34,452.69,487.49Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.33,520.28s5.2-23.36-10.68-18.24S435,516.84,447.33,520.28Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.54,524.06s11.11-18.41,22.42-15S501.33,530,473.54,524.06Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.93,561.91S451,537.85,442,548.29,452.22,569,466.93,561.91Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M483.68,557.72s-6.38-19.65,5.45-19.92S499.94,550.27,483.68,557.72Z",
    fill: "#fff"
  }))), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M472.08,467.75H472a.81.81,0,0,1-.54-.32c0-.08-7.34-9.82-11.91-11.64a.78.78,0,0,1-.45-1,.79.79,0,0,1,1-.44h0c4.31,1.73,10.39,9.23,12.12,11.52a52,52,0,0,0,11.66-15.59.79.79,0,0,1,1-.39h0a.79.79,0,0,1,.38,1c-.21.43-4.9,10.53-12.71,16.75A.85.85,0,0,1,472.08,467.75Z",
    fill: "#008fa3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M463.17,496.85h0a.79.79,0,0,1-.57-.28c0-.1-8.88-10.58-18.6-14.36a.78.78,0,0,1,.48-1.48l.07,0c8.78,3.47,16.56,11.75,18.69,14.17,11-11.08,26.19-13.16,26.83-13.25a.8.8,0,0,1,.89.68.78.78,0,0,1-.66.88h0c-.15,0-15.81,2.18-26.5,13.37A.82.82,0,0,1,463.17,496.85Z",
    fill: "#008fa3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M460.51,533.85a.8.8,0,0,1-.4-.11c-9.91-5.61-19.46-22-19.85-22.67a.78.78,0,0,1,.28-1.07.79.79,0,0,1,1.07.29h0c0,.15,9.44,16.18,18.83,21.82,2.7-2.16,17.32-13.39,29.44-15.59a.77.77,0,0,1,.91.58.09.09,0,0,1,0,0,.78.78,0,0,1-.63.9h0c-12.83,2.35-29,15.59-29.17,15.59A.73.73,0,0,1,460.51,533.85Z",
    fill: "#008fa3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M476.84,569a.75.75,0,0,1-.55-.23,39.07,39.07,0,0,0-21.29-9.3.78.78,0,0,1-.68-.87h0a.82.82,0,0,1,.89-.68,41,41,0,0,1,21.65,9.32c5.61-5.3,11.27-22.73,11.34-22.92a.78.78,0,1,1,1.53.33,1,1,0,0,1-.05.16c-.25.78-6.22,19.05-12.35,24.09A.77.77,0,0,1,476.84,569Z",
    fill: "#008fa3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M484.12,608.9s5.68-9.06,12.12-10.39,9.2-8.66,11.57-4.23S503.62,613.53,484.12,608.9Z",
    fill: "#008fa3"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "513.63 644.45 451.52 644.45 447.36 606.11 517.79 606.11 513.63 644.45",
    fill: "#1A1A1A"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.25 613.37 445.9 613.37 444.97 605.26 520.18 605.26 519.25 613.37",
    fill: "#1A1A1A"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "519.25 613.37 445.9 613.37 444.97 605.26 520.18 605.26 519.25 613.37",
    opacity: 0.2
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M472,198.49a24.41,24.41,0,0,1-.88,5.77L471,204a19.18,19.18,0,0,1,1.85,2.15,19.63,19.63,0,0,1-2.43-1.77,24.71,24.71,0,0,1,1.56-5.84Z",
    fill: "#f9aac0"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 465.25,
    cy: 197.09,
    rx: 0.92,
    ry: 1.4,
    fill: "#272727"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 479.94,
    cy: 197.09,
    rx: 0.92,
    ry: 1.4,
    fill: "#272727"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M461,193.6a36.84,36.84,0,0,1,6.23-.1.57.57,0,0,0,.63-.38c.22-.67.17-1.74-2.63-1.48C465.25,191.64,462.37,192,461,193.6Z",
    fill: "#272727"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M484.33,193.6a36.81,36.81,0,0,0-6.23-.1.55.55,0,0,1-.62-.38c-.22-.67-.18-1.74,2.62-1.48C480.1,191.64,483,192,484.33,193.6Z",
    fill: "#272727"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M468,208.31h9.44a4.79,4.79,0,0,1-3.45,3.17,5.07,5.07,0,0,1-2.26,0A4.91,4.91,0,0,1,468,208.31Z",
    fill: "#fff"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M405.73,54.64a14.69,14.69,0,0,1-.55,3.68l-.07-.21a11.08,11.08,0,0,1,1.17,1.38,13.4,13.4,0,0,1-1.56-1.12,15.61,15.61,0,0,1,1-3.73Z",
    fill: "#f9aac0"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 401.46,
    cy: 53.75,
    rx: 0.59,
    ry: 0.89,
    fill: "#272727"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 410.82,
    cy: 53.75,
    rx: 0.59,
    ry: 0.89,
    fill: "#272727"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M398.77,51.53a24.11,24.11,0,0,1,4-.07.36.36,0,0,0,.4-.24c.14-.42.11-1.11-1.68-.94A4.85,4.85,0,0,0,398.77,51.53Z",
    fill: "#272727"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M413.62,51.53a24.15,24.15,0,0,0-4-.07.35.35,0,0,1-.4-.24c-.14-.42-.11-1.11,1.67-.94A4.87,4.87,0,0,1,413.62,51.53Z",
    fill: "#272727"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M403.19,60.9h6a3,3,0,0,1-2.2,2,3.18,3.18,0,0,1-1.44,0A3.12,3.12,0,0,1,403.19,60.9Z",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 467.81,
    cy: 252.53,
    r: 126.11,
    fill: "#fff",
    opacity: 0.26
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M613.24,643.68s-7.62,5-10.29,9.18a3,3,0,0,0,1.55,4.41c2.14.65,5.91.73,12.18-2.12l9.75-4.14,3.47-12-13.22.78Z",
    fill: "#1A1A1A"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M613.24,643.68s-7.62,5-10.29,9.18a3,3,0,0,0,1.55,4.41c2.14.65,5.91.73,12.18-2.12l9.75-4.14,3.47-12-13.22.78Z",
    opacity: 0.2
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M686.66,441.42l1.05-.64.94.79S687.21,441.88,686.66,441.42Z",
    fill: "#f9acc2"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M682.15,437.75l1.1-.84,1.36,1.17S682.7,438.24,682.15,437.75Z",
    fill: "#f9acc2"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "680.07 434.16 678.49 435.56 679.23 433.44 680.07 434.16",
    fill: "#f9acc2"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M562.14,339.52c7.34,6,11.79,20.71,11.79,20.71l25.16-23.85c13.62,39.57-5.5,91.46-5.5,91.46,29.35,24.63,81.76,13.62,81.76,13.62l.79-99.59,14.14,22.54,21.23-16-13.1-30.13c-6.82-17.83-14.94-20.64-14.94-20.64l-31.11-10.35-23.15,1.13c-8.94-1.29-34.05,9.22-34.05,9.22L586,305.19Z",
    fill: "#1A1A1A"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M542.48,365.61s20.71,13,31.45-5.39c0,0-2.65-9.86-8-16.59A89.54,89.54,0,0,1,542.48,365.61Z",
    fill: "#ffb8ca"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "830.72 544.24 820.46 555.32 571.15 340.16 567.13 336.55 577.97 323.71 830.72 544.24",
    fill: "#272727"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M467.5,116.26A136.27,136.27,0,1,0,603.76,252.53,136.27,136.27,0,0,0,467.5,116.26Zm0,262.37a126.11,126.11,0,1,1,126.1-126.1A126.11,126.11,0,0,1,467.5,378.63Z",
    fill: "#EC1C24"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M560.38,532.21l52.86,111.47,12.07-3.27v10.21c26.64,9.48,45.64.77,50.82-2.12.93-.52,1.41-.85,1.41-.85l-2.19-206.19s-52.41,11-81.76-13.62l-33.21,66.91C550.1,516.2,560.38,532.21,560.38,532.21Zm50.44-9.66,14.49-29.91v56.15Z",
    fill: "#272727"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M614.14,660.26h30.92l1.22-1.22a3.94,3.94,0,0,1,2.71-1.15l6.76-.15a1,1,0,0,1,1,1v1.56h18.89a2,2,0,0,0,2-2.11,64.59,64.59,0,0,0-1.51-9.65c-5.18,2.89-24.18,11.6-50.82,2.12C615.29,652.28,614.14,660.26,614.14,660.26Z",
    fill: "#1A1A1A"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M625.31,492.64c-.21-3.81-.32-7.62-.4-11.42-.06-1.91-.06-3.81-.09-5.71l0-2.85a14.82,14.82,0,0,0-.29-2.74,15.47,15.47,0,0,0-2-5.12,16.38,16.38,0,0,0-1.65-2.22c-.61-.68-1.31-1.33-2-2l-4.06-4c-1.33-1.37-2.68-2.7-4-4.09,1.47,1.21,2.89,2.48,4.34,3.71l4.27,3.8a19.14,19.14,0,0,1,3.92,4.29,16.21,16.21,0,0,1,2.19,5.44,17,17,0,0,1,.29,2.93l0,2.87c0,1.9,0,3.8-.09,5.71C625.63,485,625.53,488.83,625.31,492.64Z",
    fill: "#231f20"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M669.1,467.87a128,128,0,0,1-14.48-18.12,110.85,110.85,0,0,1,7.65,8.73A113.06,113.06,0,0,1,669.1,467.87Z",
    fill: "#231f20"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M625.31,553.06c.22,6.87.32,13.74.41,20.61s.08,13.75.12,20.62l-.12,20.62-.15,10.3c-.08,3.44-.14,6.88-.26,10.31-.12-3.43-.17-6.87-.25-10.31l-.15-10.3-.12-20.62c0-6.87,0-13.75.12-20.62S625.1,559.93,625.31,553.06Z",
    fill: "#231f20"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M652.35,265.1v23.34s-2.53,10.65-12.73,9.06c0,0-9.06-.9-10.42-10.19v-8.16L650,263.81Z",
    fill: "#ffb8ca"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M629.2,283.15v4.16s8.23,1.77,12.69-7.09C641.89,280.22,635.92,285.78,629.2,283.15Z",
    fill: "#f9aac0"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 633.12,
    cy: 255.89,
    rx: 17.76,
    ry: 27.95,
    fill: "#ffb8ca"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M648.29,255.89c-8.53,1.28-7.1-9.81-7.1-9.81.68-8.83-1.36-10.64-1.36-10.64-2-5.44-13.14,4.75-13.14,4.75-11.1,7.25-18-2.72-18-2.72s-3.78-6.15,4.38-9.53c0,0,8.61-14.48,23.79-7.91,0,0,2.42,1.94,7,.77a17.54,17.54,0,0,1,11.53.76c4.3,1.92,8.44,5.95,7.76,14.33a85.89,85.89,0,0,1-5.23,22Z",
    fill: "#272727"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 652.57,
    cy: 260,
    rx: 7.7,
    ry: 5.4,
    transform: "translate(299.45 867.25) rotate(-81.55)",
    fill: "#ffb8ca"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M676.37,431c0,2.3,0,3.53.84,4.29a1.88,1.88,0,0,0,1.28.3c.25-.71.49-1.42.74-2.12Z",
    fill: "#ffb8ca"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M691,422.26s1.83,12.24-3.51,19.08a.6.6,0,0,1-.86.08l-1.46-1.23a.61.61,0,0,1-.17-.67l1.59-4.09a1.37,1.37,0,0,0-.76-1.75h0a1.37,1.37,0,0,0-1.81.82l-1,3a.56.56,0,0,1-.9.24l-1.29-1.13a.57.57,0,0,1-.16-.59l1-3.2a1.11,1.11,0,0,0-.67-1.45h0a1.1,1.1,0,0,0-1.41.71l-.42,1.35L676.37,431V423.1a1.45,1.45,0,0,0-1.59-1.44l-4,.4a1.4,1.4,0,0,1-1.29-2.21c1.18-1.63,4.34-3.51,12.63-3.72Z",
    fill: "#ffb8ca"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M711.51,348.43s13.52,27-4.55,49L691,422.26l-8.88-6.13s12.29-37,8.14-51.71Z",
    fill: "#ffb8ca"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 619.97,
    cy: 256.94,
    rx: 1.71,
    ry: 3.08,
    fill: "#272727"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 634,
    cy: 256.94,
    rx: 1.71,
    ry: 3.08,
    fill: "#272727"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M629.21,251.12a3,3,0,0,1,.9-1.79,4.84,4.84,0,0,1,1.7-1.12,6,6,0,0,1,2-.41,5.68,5.68,0,0,1,2,.24,9,9,0,0,1-.94.28l-.9.25a17.83,17.83,0,0,0-1.7.57A7.36,7.36,0,0,0,629.21,251.12Z",
    fill: "#272727"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M618.26,249.58a2.65,2.65,0,0,1,1.4-.53,3.87,3.87,0,0,1,1.51.14,3.51,3.51,0,0,1,2.22,1.93c-.48-.17-.89-.37-1.3-.54a12.56,12.56,0,0,0-1.21-.43,9.94,9.94,0,0,0-1.25-.32C619.2,249.74,618.76,249.66,618.26,249.58Z",
    fill: "#272727"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M625.45,256.94a47.1,47.1,0,0,1-1.74,8l-.32-.42a36.89,36.89,0,0,1,3.77.33,32,32,0,0,1-3.77.33l-.41,0a47.4,47.4,0,0,1,2.47-8.22Z",
    fill: "#f9aac0"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M623.39,270h9.07s-1.54,4.11-5.3,4.79C627.16,274.74,623.39,275.08,623.39,270Z",
    fill: "#fff"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M653.08,256.87c1.24,1.5,1.45,4.62-.73,5.38,1.31-1.58.87-3.46.73-5.38Z",
    fill: "#f9aac0"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M396.62,53.29a8.57,8.57,0,0,0,.52,1.68c-.73-.11-1.19-1.21-.52-1.68Z",
    fill: "#f9aac0"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M487.88,196.93a1.26,1.26,0,0,1,.49.84,1.88,1.88,0,0,1-.1,1,2.18,2.18,0,0,1-.54.81,1.9,1.9,0,0,1-.82.48c.22-.61.48-1.08.66-1.55A4.4,4.4,0,0,0,487.88,196.93Z",
    fill: "#f9aac0"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M457.92,198.49a4.31,4.31,0,0,0,.31,1.58c.18.48.44.94.67,1.56a2.09,2.09,0,0,1-.83-.48,2.35,2.35,0,0,1-.54-.81,2,2,0,0,1-.1-1A1.3,1.3,0,0,1,457.92,198.49Z",
    fill: "#f9aac0"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 238.22,
    cy: 211.96,
    rx: 2.89,
    ry: 5.2,
    fill: "#272727"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 261.93,
    cy: 211.96,
    rx: 2.89,
    ry: 5.2,
    fill: "#272727"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M253.83,202.13a5.07,5.07,0,0,1,1.43-3.12,7.88,7.88,0,0,1,2.9-1.94,9.66,9.66,0,0,1,3.34-.68,15.62,15.62,0,0,1,1.68.1,10.75,10.75,0,0,1,1.64.44,12.2,12.2,0,0,1-1.57.54c-.51.17-1,.34-1.51.47-1,.33-1.94.6-2.84,1a17.31,17.31,0,0,0-2.63,1.29A11.74,11.74,0,0,0,253.83,202.13Z",
    fill: "#272727"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M235.33,199.53a4.44,4.44,0,0,1,2.38-1,6.16,6.16,0,0,1,4.86,1.49,4.88,4.88,0,0,1,1.43,2.14c-.86-.24-1.55-.56-2.26-.8s-1.36-.48-2-.7-1.34-.39-2.06-.56Z",
    fill: "#272727"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M247.47,212c-.16,1.14-.35,2.27-.57,3.4s-.46,2.25-.72,3.36q-.78,3.34-1.75,6.65l-.43-.55c2.12.06,4.24.19,6.36.44-2.12.24-4.24.37-6.36.44h-.55l.13-.57c.5-2.23,1.09-4.45,1.72-6.65.32-1.1.65-2.19,1-3.28S247.06,213,247.47,212Z",
    fill: "#f9aac0"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M244,233.93h15.33s-2.61,6.94-9,8.09C250.36,242,244,242.6,244,233.93Z",
    fill: "#fff"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M282.7,215a6.23,6.23,0,0,1,1.2,2,7.8,7.8,0,0,1,.49,2.31,5.9,5.9,0,0,1-.36,2.35,4.59,4.59,0,0,1-1.33,1.93,13.05,13.05,0,0,0,.58-2.13,10,10,0,0,0,.11-2.11A25.53,25.53,0,0,0,282.7,215Z",
    fill: "#f9aac0"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 204.17,
    cy: 305.06,
    rx: 1.41,
    ry: 2.32,
    fill: "#272727"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 220.15,
    cy: 305.06,
    rx: 1.41,
    ry: 2.32,
    fill: "#272727"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M200.05,299.77a4.21,4.21,0,0,1,1.53-.92,5.89,5.89,0,0,1,1.77-.32,4.94,4.94,0,0,1,1.79.29,3.66,3.66,0,0,1,1.52.95c-.61,0-1.14-.16-1.69-.19a12.28,12.28,0,0,0-1.6-.05C202.3,299.54,201.24,299.67,200.05,299.77Z",
    fill: "#272727"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M215.43,299.4a4.19,4.19,0,0,1,1.54-.92,5.54,5.54,0,0,1,1.77-.32,5,5,0,0,1,1.79.28,3.86,3.86,0,0,1,1.52,1c-.61-.06-1.15-.17-1.69-.2a14.43,14.43,0,0,0-1.61-.05C217.68,299.16,216.63,299.29,215.43,299.4Z",
    fill: "#272727"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M210.87,305.06a42.7,42.7,0,0,1,5.41,7.47,36.4,36.4,0,0,1-5.41-.5,30.64,30.64,0,0,1,4.56-.46l-.38.71a39.9,39.9,0,0,1-4.18-7.22Z",
    fill: "#f9aac0"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M205.58,317.68l12.38.48s-3.13,5.41-7.09,4.57C210.87,322.73,207.74,322.61,205.58,317.68Z",
    fill: "#fff"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M184.3,303.77c-1.94,3.57-3.36,7.69,0,10.9-4.62-2.12-3.32-8.18,0-10.9Z",
    fill: "#f9aac0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCandidateSearch);
export default __webpack_public_path__ + "static/media/candidate-search.de741dfc4ec69514b968def889a4c3d3.svg";
export { ForwardRef as ReactComponent };